import dustingHands from "../../assets/images/svg/dusting-hands.svg";

const NoNotifications = () => {
  return (
    <div className="no-notifications-container">
      <div className="message">
        All clear! You don't have any new notifications!
      </div>

      <img src={dustingHands} alt="Dusting hands off" />
    </div>
  );
};

export default NoNotifications;
